export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const STORE_FIRE_TOKEN = "STORE_FIRE_TOKEN";
export const SET_LANG = "SET_LANG";
export const LOGOUT = "LOGOUT";